import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { FallbackRouteService } from './fallback-route.service';

export const ngxFallbackRouteServiceModule = angular.module('ngxFallbackRouteServiceModule', [])
	.factory('ngxFallbackRouteService', downgradeInjectable(FallbackRouteService) as any)
	.name;
